//Banner

import './Banner.css'

export const Banner = () => {
    // JSX
    return (
        <header className="banner">
            <img src="/images/banner-principal-moveis-planejados-manaus-am.jpg" alt="Moveis Planejados e Design de Interiores em Manaus-AM" />
            
        </header>
    );    
}

export default Banner